import type { IAngleRightNavIcon } from './helpers';

export const AngleRightNavIcon = ({ variant = 'default', ...rest }: IAngleRightNavIcon) => {
	if (variant === 'small')
		return (
			<svg
				width='16'
				height='16'
				viewBox='0 0 16 16'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.8536 7.64645C11.0488 7.84171 11.0488 8.15829 10.8536 8.35355L5.85355 13.3536C5.65829 13.5488 5.34171 13.5488 5.14645 13.3536C4.95118 13.1583 4.95118 12.8417 5.14645 12.6464L9.79289 8L5.14645 3.35355C4.95118 3.15829 4.95118 2.84171 5.14645 2.64645C5.34171 2.45118 5.65829 2.45118 5.85355 2.64645L10.8536 7.64645Z'
					fill='#022745'
				/>
			</svg>
		);

	return (
		<svg
			width='20'
			height='21'
			viewBox='0 0 20 21'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...rest}
		>
			<path
				d='M14.192 10.9738L7.94205 17.2238C7.88398 17.2819 7.81504 17.3279 7.73917 17.3593C7.6633 17.3908 7.58198 17.4069 7.49986 17.4069C7.41774 17.4069 7.33642 17.3908 7.26055 17.3593C7.18468 17.3279 7.11574 17.2819 7.05767 17.2238C6.9996 17.1657 6.95354 17.0968 6.92211 17.0209C6.89069 16.945 6.87451 16.8637 6.87451 16.7816C6.87451 16.6995 6.89069 16.6182 6.92211 16.5423C6.95354 16.4664 6.9996 16.3975 7.05767 16.3394L12.8663 10.5316L7.05767 4.72378C6.9404 4.60651 6.87451 4.44745 6.87451 4.2816C6.87451 4.11575 6.9404 3.95669 7.05767 3.83941C7.17495 3.72213 7.33401 3.65625 7.49986 3.65625C7.66571 3.65625 7.82477 3.72213 7.94205 3.83941L14.192 10.0894C14.2502 10.1475 14.2963 10.2164 14.3277 10.2923C14.3592 10.3681 14.3754 10.4495 14.3754 10.5316C14.3754 10.6137 14.3592 10.6951 14.3277 10.7709C14.2963 10.8468 14.2502 10.9157 14.192 10.9738Z'
				fill='#DFE2E2'
			/>
		</svg>
	);
};
